import { createReducer, on } from '@ngrx/store';

import * as fromSignalr from './signalr.actions';

export const signalrFeatureKey = 'signalr';

export interface SignalrState {
  initialized: boolean;
}

export const initialState: SignalrState = {
  initialized: false,
};

export const reducer = createReducer(
  initialState,
  on(fromSignalr.initSignalrConnectionSuccess, () => ({
    initialized: true,
  })),
  on(fromSignalr.stopSignalrConnection, () => ({
    initialized: false,
  })),
);
